import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class HUMACID extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">HUMACID</h1>
        </header>

        <div className="section">
          <h3>English</h3>
          <ul>
            <li><span className="label">1. Gazette Notification number and Date:</span> S.O.3743 (E) Dated 13-08-2025</li>
            <li><span className="label">2. Title of Biostimulant:</span> (28) Humate 7.15% (Liquid)</li>
            <li><span className="label">3. Composition:</span>
              <ul>
                <li>(i) Potassium humate per cent. by weight, minimum: 7.15</li>
                <li>(ii) Water per cent. by weight: QS</li>
                <li>(iii) Total (per cent): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. Crop:</span> Rice and Chilli</li>
            <li><span className="label">5. Doses:</span>
              <ul>
                <li>(i) Rice: Three foliar applications at 1250 ml/ha</li>
                <li>(ii) Chilli: Three foliar applications at 1500 ml/ha</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li><span className="label">1. राजपत्र अधिसूचना संख्या एवं दिनांक:</span> एस.ओ.3650 (ई) दिनांक 13-08-2025</li>
            <li><span className="label">2. जैवउत्तेजक का शीर्षक:</span> (28) ह्यूमिक एसिड 7.15% (द्रव)</li>
            <li><span className="label">3. संघटन:</span>
              <ul>
                <li>(i) पोटेशियम ह्यूमेट, भार के अनुसार न्यूनतम प्रतिशत: 7.15</li>
                <li>(ii) जल, भार के अनुसार प्रतिशत: क्यूएस</li>
                <li>(iii) कुल (प्रतिशत): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. फसल:</span> चावल और मिर्च</li>
            <li><span className="label">5. मात्रा:</span>
              <ul>
                <li>(i) चावल: 1250 मिली/हेक्टेयर की दर से तीन पर्णीय छिड़काव</li>
                <li>(ii) मिर्च: 1500 मिली/हेक्टेयर की दर से तीन पर्णीय छिड़काव</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li><span className="label">१. राजपत्र अधिसूचना क्रमांक आणि तारीख:</span> एस.ओ.३६५० (ई) दिनांक १३-०८-२०२५</li>
            <li><span className="label">२. बायोस्टिम्युलंटचे शीर्षक:</span> (२८) ह्युमिक आम्ल ७.१५% (द्रव)</li>
            <li><span className="label">३. रचना:</span>
              <ul>
                <li>(i) पोटॅशियम ह्युमेट टक्के. वजनाने, किमान: ७.१५</li>
                <li>(ii) पाण्याचे टक्के. वजनाने: QS</li>
                <li>(iii) एकूण (टक्के): १००.०</li>
              </ul>
            </li>
            <li><span className="label">४. पीक:</span> तांदूळ आणि मिरची</li>
            <li><span className="label">५. मात्रा:</span>
              <ul>
                <li>(i) तांदूळ: १२५० मिली/हेक्टर दराने पानांवरील तीन अनुप्रयोग</li>
                <li>(ii) मिरची: १५०० मिली/हेक्टर दराने पानांवरील तीन अनुप्रयोग</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}
